module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-superiority.5a357819.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-superiority.png
// module id = 2830
// module chunks = 11